import { Pie } from "vue-chartjs";


export default {
    extends: Pie,
    props: {
        chartData: {
            type: Array,
        },
        title: {
            type: String,
            default: () => {
                return ""
            }
        }
    },
    data() {
        return {

        };
    },
    watch: {
        chartData(newValue, OldValue) {
      
            console.log(JSON.stringify(newValue))

        }
    },
    computed: {

    },
    mounted() {

        this.InitPieChart();
    },

    methods: {
        InitPieChart() {

            let context = this;
            context.renderChart(
                {
                    labels: context.chartData.map(x => x.label),
                    datasets: [
                        {
                            backgroundColor: context.chartData.map(x => x.color),
                            data: context.chartData.map(x => x.value)
                        }
                    ]
                },
                {
                    maintainAspectRatio: true,
                    responsive: true,
                    title: {
                        display: true,
                        fontSize: 20,
                        text: this.title
                    },
                    legend: {
                        display: true,
                        labels: {
                            boxWidth: 10,
                            fontSize: 15,
                            padding: 5
                        }
                    }
                }
            );
        }
    },

};
